import api from '~/services/api';

const salesforceMarketingCloud = {
  authMarketingCloud: (firebaseToken, store, roles) => {
    
    const header = {
      'content-type': 'application/json',
      client_id: process.env.REACT_APP_CLIENT_ID,
      access_token: localStorage.getItem("access_token")
    };
    
    const parameters = {
      method: 'POST',
      headers: header
    };

    const body = {
      role: roles.currentRole.name,
      storeId: store.storeId,
      firebaseToken: firebaseToken,
      customerSiteId: store.addressCode,
      customerId: store.storeCode,
    };

    api
      .post("/notifications/register", body, parameters)
      .then()
      .catch(err => {
        console.error('err =>', err);
      });
  },
};

export default salesforceMarketingCloud;